//  Place for export Links

// NEWS

 let newsURL =  'http://api.mediastack.com/v1/news?access_key=433aa9b7a2bff48dfaebea161d3df589&countries=gb,us&languages=en&date=today&categories=business,entertainment,health,science,technology'

//  let newsURL = '' //save API request


 

// optional parameters: 
    // & sources = cnn,bbc
    // & categories = business,sports
    // & countries = us,au
    // & languages = en,-de
    // & keywords = virus,-corona
    // & sort = published_desc
    // & offset = 0
    // & limit = 100'

// NEWS

// Weather

 let weatherURL = 'http://api.weatherstack.com/current?access_key=50503b0fda8f68c90740353745b5b35e&query=fetch:ip&units=m'

//  let weatherURL = '' // save API request

// Weather 






 export {newsURL, weatherURL}; 